module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-20"
  }, [_c('router-link', {
    staticClass: "btn-link-large add-btn",
    attrs: {
      "to": "add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加部门\n\t\t\t")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.pane_height
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "部门结构",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "部门名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("\n            " + _vm._s(_vm._f("status")(scope.row.status)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'structuresEdit',
                params: {
                  id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDelete(scope.row)
            }
          }
        }, [_vm._v("\n  \t\t\t\t\t\t删除\n  \t\t\t\t\t\t")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'structures'
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a4b4db5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/structures/structures/list.vue
// module id = 1869
// module chunks = 2